<div class="time-picker-container" [class.disabled]="disabled">
  <div
    class="time-picker-input"
    [class.open]="isOpen"
    [class.required]="required"
    (click)="toggleDropdown()"
    (keydown)="onKeyDown($event)"
    (blur)="onBlur()"
    tabindex="0"
    role="combobox"
    [attr.aria-expanded]="isOpen"
    [attr.aria-disabled]="disabled"
  >
    <span class="time-display" [class.placeholder]="!value">
      {{ value || placeholder }}
    </span>
    <span class="dropdown-arrow" [class.open]="isOpen">▼</span>
  </div>

  <div
    class="time-picker-dropdown"
    *ngIf="isOpen"
    (click)="$event.stopPropagation()"
  >
    <div class="time-selectors">
      <div class="hour-selector">
        <label>{{ "listSites.hour" | translate }}</label>
        <div class="selector-list">
          <div
            *ngFor="let hour of hours"
            class="selector-item"
            [class.selected]="selectedHour === hour"
            (mousedown)="selectHour(hour); $event.preventDefault()"
          >
            {{ hour.toString().padStart(2, "0") }}
          </div>
        </div>
      </div>

      <div class="minute-selector">
        <label>{{ "listSites.minute" | translate }}</label>
        <div class="selector-list">
          <div
            *ngFor="let minute of minutes"
            class="selector-item"
            [class.selected]="selectedMinute === minute"
            (mousedown)="selectMinute(minute); $event.preventDefault()"
          >
            {{ minute.toString().padStart(2, "0") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
